import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=7a31114f&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"
import style0 from "./couponList.vue?vue&type=style&index=0&id=7a31114f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a31114f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a31114f')) {
      api.createRecord('7a31114f', component.options)
    } else {
      api.reload('7a31114f', component.options)
    }
    module.hot.accept("./couponList.vue?vue&type=template&id=7a31114f&scoped=true", function () {
      api.rerender('7a31114f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/couponList.vue"
export default component.exports